interface DefaultQueryParams {
  success?: string
  connectionId?: string
}

export const DEFAULT_QUERY_PARAMS: DefaultQueryParams = { success: undefined, connectionId: undefined }
